import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

const accountType = ImmutablePropTypes.map.isRequired;
const enabled = PropTypes.bool;
const groupErrors = ImmutablePropTypes.map.isRequired;
const ca = ImmutablePropTypes.list;
const dataModified = PropTypes.bool;
const configurations = ImmutablePropTypes.list.isRequired;
const newConfiguration = PropTypes.bool.isRequired;

export {
  accountType,
  enabled,
  groupErrors,
  ca,
  dataModified,
  configurations,
  newConfiguration,
};
